import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  KeyboardArrowUp as ArrowUpIcon,
  KeyboardArrowDown as ArrowDownIcon,
  UnfoldMore as UnfoldMoreIcon,
} from '@mui/icons-material';
import { SortField, Order } from '../types';

interface HeaderCellProps {
  children: React.ReactNode;
  align?: 'left' | 'right' | 'center';
  sortField?: SortField;
  orderBy: SortField;
  order: Order;
  onSort?: (field: SortField) => void;
}

/**
 * Заголовочная ячейка таблицы с поддержкой сортировки.
 * При наличии `sortField` становится кликабельной и показывает иконку направления.
 */
const HeaderCell: React.FC<HeaderCellProps> = ({
  children, align = 'left', sortField, orderBy, order, onSort,
}) => {
  const isActive = sortField && orderBy === sortField;
  return (
    <Box
      onClick={sortField && onSort ? () => onSort(sortField) : undefined}
      sx={{
        display: 'flex', alignItems: 'center', gap: 0.5,
        justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
        cursor: sortField ? 'pointer' : 'default',
        userSelect: 'none',
        '&:hover': sortField ? { color: 'text.primary' } : {},
      }}
    >
      <Typography
        variant="subtitle2"
        color={isActive ? 'text.primary' : 'text.secondary'}
        fontWeight={700}
        sx={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}
      >
        {children}
      </Typography>
      {sortField && (isActive
        ? (order === 'asc' ? <ArrowUpIcon sx={{ fontSize: 14 }} /> : <ArrowDownIcon sx={{ fontSize: 14 }} />)
        : <UnfoldMoreIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
      )}
    </Box>
  );
};

export default HeaderCell;
